

import { useSelector } from "react-redux";
import { Card, Table, Typography, Spin } from 'antd';
import { useGetAngeloneHoldingQuery } from "../slices/angelOneApiSlice";
import "./css/Dashboard.css";
const { Title, Text } = Typography;

const holdingColumns = [
  {
    title: 'Symbol',
    dataIndex: 'tradingsymbol',
    key: 'symbol',
  },
  {
    title: 'Exchange',
    dataIndex: 'exchange',
    key: 'exchange',
    className: 'no-wrap-header',
  },
  {
    title: 'Qty',
    dataIndex: 'quantity',
    key: 'qty',
    onCell: () => ({
      style: { whiteSpace: 'nowrap' },
    }),
  },
  {
    title: 'Avg. Price',
    dataIndex: 'averageprice',
    key: 'avgPrice',
    render: (value) => `₹${Number(value || 0).toFixed(2)}`,
    onCell: () => ({
      style: { whiteSpace: 'nowrap' },
    }),
  },
  {
    title: 'LTP',
    dataIndex: 'ltp',
    key: 'ltp',
    render: (value) => `₹${Number(value || 0).toFixed(2)}`
  },
  {
    title: 'P&L',
    key: 'pnl',
    render: (_, row) => {
      const pnl =
        Number(row?.profitandloss ??
          (Number(row?.ltp || 0) * Number(row?.quantity || 0)));

      return (
        <span style={{ color: pnl >= 0 ? 'green' : 'red' }}>
          ₹{pnl.toFixed(2)}
        </span>
      );
    },
    onCell: () => ({
      style: { whiteSpace: 'nowrap' },
    }),
  },
  {
    title: 'PnL %',
    key: 'pnlPercentage',
    render: (_, row) => {
      const avg = Number(row?.averageprice || 0);
      const ltp = Number(row?.ltp || 0);

      const percent =
        avg > 0 ? ((ltp - avg) / avg) * 100 : 0;

      return (
        <span style={{ color: percent >= 0 ? 'green' : 'red' }}>
          {percent.toFixed(2)}%
        </span>
      );
    }
  },
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
    render: (v) => v || "-"
  },
  {
    title: 'ISIN',
    dataIndex: 'isin',
    key: 'isin',
    render: (v) => v || "-"
  },
];


const HoldingScreen = ({broker}) => {
// console.log(broker);


  const { userInfo } = useSelector((state) => state.auth); // Assuming you store logged-in user info here
  const userId = userInfo?._id;
  // console.log(userId);
  
const { data: holdingsData, isLoading } =
  useGetAngeloneHoldingQuery({
    userId,
    broker,
  });
  const { darkmode } = useSelector((state) => state.darkmode);
// console.log("holdings..",holdingsData);
  return (
    <Card
      title="Holdings"
      bordered={false}
      className="card_hover"
      style={{
        backgroundColor: darkmode ? "#1f1f1f" : "#fff",marginTop:"30px",

        // overflowX: "auto",height:"500px",marginTop:"30px"

      }}
    >
      {isLoading ? (
  <Spin />
) : (
  <div style={{ overflowX: 'auto',overflowY:"auto" }}>
    <Table
      // dataSource={Array.isArray(holdingsData?.holdings) ? holdingsData.holdings : []}
        // dataSource={Array.isArray(holdingsData?.holdings?.data) ? holdingsData.holdings.data : []}
dataSource={holdingsData?.holdings || []}

      columns={holdingColumns}
      pagination={false}
scroll={{ x: 'max-content' }}
      bordered
      // scroll={{ x: true,y :true }}
      style={{ overflowX: 'auto', }}
      rowKey="tradingsymbol"
    />
  </div>
)}

    </Card>
  );
};

export default HoldingScreen;

